import axios from 'axios';

const API_URL = 'https://panel.imigo.app/api';

// Fetch all posts with pagination and filters
export const fetchPosts = async (params = {}) => {
  try {
    const response = await axios.get(`${API_URL}/posts`, {
      params: {
        'filters[is_active]': true,
        'populate[creator][fields][0]': 'name',
        'populate[creator][fields][1]': 'picture',
        'populate[creator][fields][2]': 'id',
        'populate[creator][populate][picture][fields][0]': 'url',
        'populate[creator][populate][picture][fields][1]': 'formats',
        'populate[nationality][fields][0]': 'language',
        'populate[nationality][fields][1]': 'language_query',
        'populate[nationality][fields][2]': 'is_rtl',
        'populate[nationality][populate][flag][fields][0]': 'url',
        'populate[post_type][fields][0]': 'name',
        'populate[picture][fields][0]': 'formats',
        'sort[0]': 'stick_top:desc',
        'sort[1]': 'sticky_order:desc',
        'sort[2]': 'createdAt:desc',
        'pagination[start]': params.start || 0,
        'pagination[limit]': params.limit || 8,
        'fields[0]': 'title',
        'fields[1]': 'description',
        'fields[2]': 'stick_top',
        'fields[3]': 'price',
        'fields[4]': 'start',
        'fields[5]': 'end',
        'fields[6]': 'createdAt',
        'fields[7]': 'sticky_order',
        'fields[8]': 'is_imigo_partner',
        'fields[9]': 'slug', // Make sure slug is explicitly requested
        ...params.filters
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching posts:', error);
    throw error;
  }
};

// Fetch posts by post type
export const fetchPostsByType = async (postType, params = {}) => {
  try {
    const response = await fetchPosts({
      ...params,
      filters: {
        ...params.filters,
        'filters[post_type][name]': postType
      }
    });
    return response;
  } catch (error) {
    console.error(`Error fetching ${postType} posts:`, error);
    throw error;
  }
};

// Fetch single post by ID or slug
export const fetchPostById = async (idOrSlug) => {
  try {
    // Check if the parameter is a number (ID) or string (slug)
    const isId = !isNaN(parseInt(idOrSlug));
    
    if (isId) {
      // Original ID-based fetch
      const response = await axios.get(`${API_URL}/posts/${idOrSlug}`, {
        params: {
          'populate[0]': 'picture',
          'populate[1]': 'post_type',
          'populate[2]': 'creator.picture',
          'populate[3]': 'nationality',
          'populate[4]': 'gallery',
          'populate[5]': 'post.picture',
          'populate[6]': 'information',
          'populate[7]': 'post_category',
          'populate[8]': 'map',
          'populate[9]': 'area',
          'populate[10]': 'city'
        }
      });
      return response.data;
    } else {
      // Slug-based fetch
      const response = await axios.get(`${API_URL}/posts`, {
        params: {
          'filters[slug][$eq]': idOrSlug,
          'populate[0]': 'picture',
          'populate[1]': 'post_type',
          'populate[2]': 'creator.picture',
          'populate[3]': 'nationality',
          'populate[4]': 'gallery',
          'populate[5]': 'post.picture',
          'populate[6]': 'information',
          'populate[7]': 'post_category',
          'populate[8]': 'map',
          'populate[9]': 'area',
          'populate[10]': 'city'
        }
      });
      
      // If there's no post with this slug, throw an error
      if (!response.data.data || response.data.data.length === 0) {
        throw new Error('Post not found');
      }
      
      // Return the first post data in the format expected by the app
      return {
        data: response.data.data[0]
      };
    }
  } catch (error) {
    console.error('Error fetching post:', error);
    throw error;
  }
};

// Fetch post by slug
export const fetchPostBySlug = async (slug) => {
  try {
    const response = await axios.get(`${API_URL}/posts`, {
      params: {
        'filters[slug]': slug,
        'populate[0]': 'picture',
        'populate[1]': 'post_type',
        'populate[2]': 'creator.picture',
        'populate[3]': 'nationality',
        'populate[4]': 'gallery',
        'populate[5]': 'post.picture',
        'populate[6]': 'information',
        'populate[7]': 'post_category',
        'populate[8]': 'map',
        'populate[9]': 'area',
        'populate[10]': 'city'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching post by slug:', error);
    throw error;
  }
};

// Fetch post types
export const fetchPostTypes = async () => {
  try {
    const response = await axios.get(`${API_URL}/post-types`);
    return response.data;
  } catch (error) {
    console.error('Error fetching post types:', error);
    throw error;
  }
};

export default {
  fetchPosts,
  fetchPostsByType,
  fetchPostById,
  fetchPostBySlug,
  fetchPostTypes
}; 